
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { AspectRatio } from "@/components/ui/aspect-ratio";

interface WelcomeVideoModalProps {
  videoId: string;
  open: boolean;
  onClose: () => void;
}

export function WelcomeVideoModal({ videoId, open, onClose }: WelcomeVideoModalProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => {
      if (!isOpen) onClose();
    }}>
      <DialogContent className="sm:max-w-md p-0 overflow-hidden rounded-xl">
        <div className="relative pt-0 pb-0">
          <AspectRatio ratio={4 / 5} className="w-full">
            <iframe
              width="100%"
              height="100%" 
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1&playsinline=1&modestbranding=1&rel=0`}
              title="Match My Logic Rules"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0"
            ></iframe>
          </AspectRatio>
        </div>
      </DialogContent>
    </Dialog>
  );
}
